module.exports = __webpack_public_path__ + "static/media/event-04.1344bc35.jpg";